import React from 'react';
import classNames from 'classnames';

import WindIndicator from 'components/WindIndicator';
import PlayMarker from 'components/Icons/PlayMarker';
import type { Units } from 'types/units';

import styles from './SpotThumbnail.module.scss';

interface SpotThumbnailProps {
  windDirection: number;
  windSpeed: number;
  units: Units;
  hasCamera?: boolean;
}

const SpotThumbnail: React.FC<SpotThumbnailProps> = ({
  windDirection,
  windSpeed,
  units,
  hasCamera = false,
}) => (
  <div className={classNames(styles.spotThumbnail, 'quiver-spot-thumbnail')}>
    <div className="quiver-spot-thumbnail__top-container">
      <WindIndicator direction={windDirection} speed={windSpeed} units={units.windSpeed} />
    </div>
    <div className="quiver-spot-thumbnail__bottom-container">
      {hasCamera ? <PlayMarker /> : null}
    </div>
  </div>
);

export default SpotThumbnail;
